import { render } from "./QualityGroupsWeight.vue?vue&type=template&id=ef12004a&ts=true"
import script from "./QualityGroupsWeight.vue?vue&type=script&lang=ts"
export * from "./QualityGroupsWeight.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__